import React, { useEffect, useState } from 'react';
import { TrevorIcon, TrevorComponent } from '@trevor/ui-components';
import { EDITABLE_FIELD_INPUT } from '@/constants/test-ids';

export type EditableFieldProps = {
  value: string;
  placeholder: string;
  handleInput?: F<string>;
  displayEditIcon?: boolean;
  onEditStateChange?: F<boolean>;
  tabIndex?: number;
  activateOnFocus?: boolean;
};

export const EditableField: TrevorComponent<EditableFieldProps> = ({
  value = '',
  placeholder,
  handleInput,
  className,
  displayEditIcon,
  onEditStateChange,
  tabIndex,
  activateOnFocus,
}) => {
  const [isEditing, setEditing] = useState(false);
  const [previousValue, setPreviousValue] = useState(value);
  const [currentValue, setCurrentValue] = useState(value);

  useEffect(() => {
    if (onEditStateChange) {
      onEditStateChange(isEditing);
    }
    if (!isEditing && handleInput && value !== currentValue) {
      handleInput(currentValue);
    }
  }, [isEditing]);

  useEffect(() => {
    setCurrentValue(value);
  }, [value]);

  const handleKey = (e: React.KeyboardEvent) => {
    if (e.key === 'Escape') {
      setEditing(false);
      setCurrentValue(previousValue);
    }
    if (e.key === 'Enter') {
      setEditing(false);
    }
  };

  const activate = () => {
    if (activateOnFocus) {
      setEditing(true);
    }
  };

  return (
    <div className={className}>
      {isEditing ? (
        <input
          data-test-id={EDITABLE_FIELD_INPUT}
          autoFocus
          value={currentValue}
          onBlur={() => setEditing(false)}
          onChange={(e) => setCurrentValue(e.target.value)}
          onKeyDown={handleKey}
        />
      ) : (
        <div
          onClick={() => {
            setEditing(true);
            setPreviousValue(value);
          }}
          tabIndex={tabIndex}
          onFocus={activate}
        >
          <span>{currentValue || placeholder}</span>
          {displayEditIcon && <TrevorIcon name="edit" size={13} />}
        </div>
      )}
    </div>
  );
};
